import React from 'react';

import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import { LANGUAGES } from '../../../util/languages';

type InputProps = {
  value: string;
  onChange: (value: string) => void;
};

/**
 * This selector is currently only used for selecting translation languages and
 * differs slightly from the LanguageSelector in that it does not bifurcate
 * English/Spanish language selection from "Other" selections into a separate
 * input. Rather, this is a singular Autocomplete that spans all ISO languages
 * but groups English and Spanish at the top of the Autocomplete options
 */
export const TranslationLanguageSelector = ({ value, onChange }: InputProps) => {
  const handleSelection = (_event: React.ChangeEvent<{}>, newValue: [string, string] | null) => {
    onChange(newValue ? newValue[0] : '');
  };

  const shouldDisplayInFirstGroup = (item: [string, string]) => ['en', 'es'].includes(item[0]);
  const autocompleteItems = Object.entries(LANGUAGES).sort(
    (a, b) => +shouldDisplayInFirstGroup(b) - +shouldDisplayInFirstGroup(a),
  );

  const getGroupName = (item: (typeof autocompleteItems)[number]) =>
    shouldDisplayInFirstGroup(item) ? '' : 'Other';

  const selection = autocompleteItems.find(([code]) => code === value) || null;

  return (
    <Autocomplete
      value={selection}
      options={autocompleteItems}
      groupBy={getGroupName}
      getOptionLabel={(option) => option[1]}
      onChange={handleSelection}
      size="small"
      renderInput={(params) => (
        <TextField {...params} margin="normal" variant="outlined" required />
      )}
      data-cy="translation-language-selector"
    />
  );
};
